<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                <h1 class="page-title"><span *ngIf="pageType==1">IPD</span> <span *ngIf="pageType==2">Elective</span> List</h1>
            </div>
            <div class="col-sm-6 pull-right text-right" *ngIf="myrole=='1' || myrole=='4'">
                <button *ngIf="userId=='167' || userId=='89'" type="button" class="btn btn-success" (click)="showIPDAssignedToUpdateModal()"><i class="fa fa-upload"></i> Upload PX Assignment CSV</button>
                <button type="button" class="btn btn-success ml-2" [disabled]="pre_op_loading" (click)="sendPreOperativeDeatils()"><i class="fa fa-solid fa-share" [ngClass]="{'fa-spin':pre_op_loading}"></i> Send Pre-Operative Instruction</button>
                <button  type="button" class="btn btn-success ml-2" [disabled]="post_op_loading" (click)="sendPostOperativeDeatils()"><i class="fa fa-solid fa-share" [ngClass]="{'fa-spin':post_op_loading}"></i> Send Post-Operative Instruction</button>
            </div>
        </div>
        
        
    </div>

    <div class="container-fluid px-4 pt-4 card" >
        <mat-accordion class="example-headers-align" multi *ngIf="myrole!='13'">
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                    <div class="row mb-2 mt-2">
                        <div class="col-sm-2 mt-2"><input class="form-control" [(ngModel)]="search" type="text" placeholder="Search" /></div>
                        <div class="col-sm-2 mt-2" *ngIf="myrole=='1' || myrole=='3'  || myrole=='4' || myrole=='9' || myrole=='10' || myrole=='15' || myrole=='18'">
                            <mat-select  placeholder="Bds" [(ngModel)]="bd" (click)="setSearchValue('lead_owner')" multiple>
                                <input class="mySearchInput"
                                #ownerSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'lead_owner')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="ownerSearch">
                                <mat-option value="{{bd.id}}" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Circle" [(ngModel)]="circle" multiple>
                                <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2" *ngIf="doctorFilter">
                            <mat-select  placeholder="Doctor" [(ngModel)]="doctor" (click)="setSearchValue('doctor')" multiple>
                                <input class="mySearchInput"
                                #doctorSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'doctor')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="doctorSearch">
                                <mat-option [value]="odoctor.id" *ngFor="let odoctor of doctors">{{odoctor.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2" *ngIf="hospitalFilter">
                            <mat-select  placeholder="Hospital" [(ngModel)]="hospital" (click)="setSearchValue('hospital')" multiple>
                                <input class="mySearchInput"
                                #hospitalSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'hospital')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="hospitalSearch">
                                <mat-option >All</mat-option>
                                <mat-option [value]="ohospital.id" *ngFor="let ohospital of hospitals">{{ohospital.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Treatment" [(ngModel)]="treatment" (click)="setSearchValue('treatment')" multiple>
                                <input class="mySearchInput"
                                #treatmentSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'treatment')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="treatmentSearch">
                                <mat-option value="{{ltreatment.id}}" *ngFor="let ltreatment of treatments">{{ltreatment.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Status" [(ngModel)]="status" multiple>
                                <mat-option value="0">Active</mat-option>
                                <mat-option value="1">Completed</mat-option>
                                <mat-option value="3">Cancelled</mat-option>
                                <mat-option value="4">Postponed</mat-option>
                                <mat-option value="2" *ngIf="myrole=='1' || myrole=='4'">Deleted</mat-option>

                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2" *ngIf="myrole!='2' && myrole!='16'">
                            <mat-select  placeholder="Lead Source" [(ngModel)]="lead_source" multiple>
                                <mat-option value="{{lsources.id}}" *ngFor="let lsources of lead_sources">{{lsources.source_name}}</mat-option>

                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Payment Mode"  [(ngModel)]="payment_mode" multiple>
                                <mat-option value="1">Cash</mat-option>
                                <mat-option value="2">Cashless</mat-option>
                                <mat-option value="3">Reimbursement</mat-option>
                                <mat-option value="4">EMI</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Feedback Status"  [(ngModel)]="feedbackStatus" multiple>
                                <!-- <mat-option>All</mat-option> -->
                                <mat-option value="null">Pending</mat-option>
                                <mat-option value="1">Active</mat-option>
                                <mat-option value="2">Follow-Up 1</mat-option>
                                <mat-option value="3">Follow-Up 2</mat-option>
                                <mat-option value="4">Not Received</mat-option>
                                <mat-option value="5">Completed</mat-option>
                                <mat-option value="6">Closed</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Lead Catergory"  [(ngModel)]="lead_category_filter" multiple>
                                <mat-option value="{{catergory.id}}" *ngFor="let catergory of treatCategory">{{catergory.name}}</mat-option>
                            </mat-select>
                          </div>
                          <div class="col-sm-2 mt-2">
                            <mat-select placeholder="Gender" [(ngModel)]="gender">
                                <mat-option value="">All</mat-option>
                                <mat-option value="Male">Male</mat-option>
                                <mat-option value="Female">Female</mat-option>
                            </mat-select>
                        </div>  
                        <div class="col-sm-3 mt-2">
                            <mat-form-field appearance="fill">
                                <mat-label>Enter a date range</mat-label>
                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate #dateRangeStart placeholder="Start date">
                                    <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>
                            </mat-form-field>
                            <mat-icon (click)="clearDate()">clear</mat-icon>
                        </div>

                        <div class="col-sm-3 mt-2" *ngIf="myrole=='1' || myrole=='4' ">
                            <mat-form-field appearance="fill">
                                <mat-label>Feedback Follow up date range</mat-label>
                                <mat-date-range-input [rangePicker]="picker1">
                                    <input matStartDate #followupDateRangeStart placeholder="Start date">
                                    <input matEndDate #followupDateRangeEnd placeholder="End date" (dateChange)="followupDateRangeChange(followupDateRangeStart, followupDateRangeEnd)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker1></mat-date-range-picker>
                            </mat-form-field>
                            <mat-icon (click)="clearFollowupDate()">clear</mat-icon>
                        </div>

                        <div class="col-sm-3 mt-2">
                            <div class="col-sm-12">
                                <p class="m-10" *ngIf="myrole=='1' || myrole=='9'">
                                    <label class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" [(ngModel)]="is_specialCase" />
                                    <span class="custom-control-label">Show Special Case IPD</span>
                                    </label>
                                  </p>
                            </div>
                        </div>
                        <div class="col-sm-2 mt-4" *ngIf="myrole=='1' || (myrole=='4' && is_doctor_access=='1')">
                            <mat-select  placeholder="Mdspok" [(ngModel)]="mdspok" (click)="setSearchValue('mdspok')">
                                <input class="mySearchInput"
                                #mdspokSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'mdspok')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="mdspokSearch">
                                <mat-option value="{{mdspok.id}}" *ngFor="let mdspok of mdSpokData">{{mdspok.name}}</mat-option>
                            </mat-select>
                        </div>


                        <div class="col-sm-3 mt-4">
                            <button type="button" class="btn btn-primary ml-2 mb-4" (click)="loadIpds(0,perpage)"> <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                            <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i class="fa fa-sync"></i> Reset Filters</button>
                          </div>

                </div>
                </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3">
                    <button type="button" class="btn btn-success" [disabled]="loading" (click)="loadIpds(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh List</button>
                     <!-- Admin,Insuarance, Finance, Training & Quality, Central OPS, Kuwarjeet and Sourabh -->
                    <button *ngIf="myrole=='1' || (myrole=='3' && isCMAccess=='1') || myrole=='4' || myrole=='8' || myrole=='5' || myrole=='9' || myrole=='15' || myrole=='18' || userId=='58' || userId=='88'" type="button" class="btn btn-success ml-2" [disabled]="loading" (click)="exportIpdList()"><i class="fa fa-file-excel"></i> Export List</button>
                    <!-- <button *ngIf="myrole=='1' || (myrole=='3' && is_presales_access=='1')" type="button" class="btn btn-success ml-2" [disabled]="loading" (click)="exportPartnerDataList()"><i class="fa fa-file-excel"></i> Export Partner Data</button> -->

                    <!-- <span *ngIf="myrole=='1'"><a class="float-right btn btn-success text-white" (click)="showModalGlamyoShares()"><i class="fa fa-file-excel"></i> Import Ipd Shares</a><br>
                    <a class="float-right" href="{{sc3Url}}crm/shares/ipd_shares.csv" target="_blank">Sample CSV</a></span>  -->

                </div>
                <div class="col-sm-6"><mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator></div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>#</th>
                        <!-- <th>Payment Link Send</th> -->
                        <th>Status</th>
                        <th>Lead Status</th>
                        <th>Medical Officer Action Status</th>
                        <th>Feedback Status</th>
                        <th *ngIf="myrole!='2'">Lead Source</th>
                        <th class="tablefixcoloumn">Appointment Id</th>
                        <th class="tablefixcoloumn">Glamyo Patient Id</th>
                        <th class="tablefixcoloumn">Glamyo Appointment Id</th>
                        <th class="tablefixcoloumn">Patient Name</th>
                        <!-- <th *ngIf="userId!='16' && myrole!='10' && myrole!='18'  && myrole!='6'">Patient Mobile</th> -->
                        <th>Patient Mobile</th>
                        <th *ngIf="myrole=='1' || myrole=='4'">Kaleyra C2C</th>
                        <th *ngIf="myrole=='1' || myrole=='4'">Call Details</th>
                        <th>Patient Age</th>
                        <th>Patient Gender</th>
                        <th>Lead Circle</th>
                        <th>IPD Circle</th>
                        <th>Lead Owner</th>
                        <th>Employee Id</th>
                        <th>Treatment</th>
                        <th>Treatment Catergory</th>
                        <th>Doctor</th>
                        <th>Hospital</th>
                        <th>Room Catergory</th>
                        <th>Room Capping</th>
                        <th>Payment Mode</th>
                        <th>EMI Vender Name</th>
                        <th>Lead Date</th>
                        <th>Surgery Date</th>
                        <th>Arrival DateTime</th>
                        <th>Treatment Time</th>
                        <th *ngIf="myrole!='6' && myrole!='13'">On Admission</th>
                        <th *ngIf="myrole!='6' && myrole!='13'">On Discharge</th>
                        <th *ngIf="myrole!='6' && myrole!='13'">Billed Amount</th>
                        <!-- for insurance role type -->
                        <th *ngIf="myrole=='5' || myrole=='1' || myrole=='15'">TPA</th>
                        <th *ngIf="myrole=='5' || myrole=='1' || myrole=='15'">Insurance Company</th>
                        <th *ngIf="myrole=='5' || myrole=='1' || myrole=='15'">Policy Number</th>
                        <th *ngIf="myrole=='5' || myrole=='1' || myrole=='15'">Corporate Name</th>
                        <th *ngIf="myrole=='5' || myrole=='1' || myrole=='15'">Copay</th>
                        <th *ngIf="myrole=='5' || myrole=='1' || myrole=='15'">Remarks</th>
                        <!-- for insurance role type -->
                        <th *ngIf="myrole!='13'">Aadhar</th>
                        <th *ngIf="myrole!='13'">Insurance</th>
                        <th *ngIf="myrole!='13'">Discharge Summary</th>
                        <th *ngIf="myrole!='13'">Bill Copy</th>
                        <th *ngIf="myrole!='13'">Pre-Auth</th>
                        <th *ngIf="myrole!='13'">Pre-Approval</th>
                        <th *ngIf="myrole!='13'">Final Approval</th>
                        <th *ngIf="myrole!='13'">Settlement Letter</th>
                        <th *ngIf="myrole!='13'">Other Document</th>
                        <th>Feedback Person</th>
                        <th>Approved Person</th>
                        <th>Campaign Name</th>
                        <th>Keywords</th>
                        <th>AD Group Id</th>
                        <th>Match Type</th>
                        <th>Form Lead Source</th>
                        <th *ngIf="myrole=='1' || myrole=='4' ">Feedback Follow Up Date</th>
                        <th *ngIf="myrole=='1' || (myrole=='4' && isCMAccess=='1')">Assigned To</th>
                        <th *ngIf="myrole=='1' || (myrole=='4' && isCMAccess=='1')">Assign To</th>
                        <th *ngIf="myrole=='1' || myrole=='15'">Patient Journey Details</th>
                        <th *ngIf="myrole!='13' && myrole!='15' && myrole!='10' && myrole!='7'">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let ipd of ipds;let index = index;">
                        <td >{{(pageIndex*perpage)+index+1}}</td>
                        <!-- <td><span class='p-2 badge badge-info' (click)="sharePaymentLink()">Share Payment Link</span></td> -->
                        <td>
                            <span class='p-2 badge' [ngClass]="{'badge-info':ipd.status==0}" *ngIf="ipd.status==0"><i class="fa fa-dot-circle"></i> Active</span>
                            <span class='p-2 badge' [ngClass]="{'badge-success':ipd.status==1}" *ngIf="ipd.status==1"><i class="fa fa-check"></i> Completed</span>
                            <span class='p-2 badge' [ngClass]="{'badge-danger':ipd.status==3}" *ngIf="ipd.status==3"><i class="fa fa-times"></i> Cancelled</span>
                            <span class='p-2 badge' [ngClass]="{'badge-secondary':ipd.status==4}" *ngIf="ipd.status==4"><i class="fa fa-atom"></i> Postponed</span>
                        </td>
                        <td>{{ipd.leadStatus}}</td>
                        <td>
                          <span class='p-2 badge' [ngClass]="{'badge-success':ipd.approved_status==1}" *ngIf="ipd.approved_status==1"><i class="fa fa-check"></i> Approved</span>
                          <span class='p-2 badge' [ngClass]="{'badge-danger':ipd.approved_status==2}" *ngIf="ipd.approved_status==2"><i class="fa fa-dot-circle"></i> Rejected</span>
                          <span class='p-2 badge' [ngClass]="{'badge-info':ipd.approved_status==3}" *ngIf="ipd.approved_status==3"><i class="fa fa-times"></i> Approved with High Risk</span>
                        </td>
                        <td>
                            <span class='p-2 badge btn-primary' *ngIf="ipd.feedbackStatus==1"><i class="fa fa-dot-circle"></i> Active</span>
                            <span class='p-2 badge btn-info' *ngIf="ipd.feedbackStatus==2"><i class="fa fa-dot-circle"></i> Follow-Up 1</span>
                            <span class='p-2 badge btn-info' *ngIf="ipd.feedbackStatus==3"><i class="fa fa-dot-circle"></i> Follow-Up 2</span>
                            <span class='p-2 badge btn-danger' *ngIf="ipd.feedbackStatus==4"><i class="fa fa-times"> </i> Not Received</span>
                            <span class='p-2 badge btn-success' *ngIf="ipd.feedbackStatus==5"><i class="fa fa-check"></i> Completed</span>
                            <span class='p-2 badge btn-dark' *ngIf="ipd.feedbackStatus==6"><i class="fa fa-check"></i> Closed</span>
                            <span class='p-2 badge btn-warning' *ngIf="!ipd.feedbackStatus"><i class="fa fa-times"> </i> Pending</span>
                        </td>
                        <td *ngIf="myrole!='2'">
                            <!-- <span class='p-2 badge btn-primary'>{{sharedapi.getLeadSource(ipd.lead_source)}}</span> -->
                            <span class='p-2 badge btn-primary'>{{ipd.source_name}}</span>
                            <span  *ngIf="ipd.referral_type">
                                <span>({{getRefferalType(ipd.referral_type)}} - {{ipd.referral_person_name}})</span> <br>
                            </span>
                        </td>
                        <td class="tablefixcoloumn">{{ipd.patient_id}}</td>
                        <td class="tablefixcoloumn">{{ipd.glamyo_patient_id}}</td>
                        <td class="tablefixcoloumn">GHIPD{{ipd.id}}</td>
                        <td class="tablefixcoloumn">{{ipd.patient}}</td>
                        <!-- <td *ngIf="userId!='16' && myrole!='10'  && myrole!='18'  && myrole!='6'">{{ipd.phone}}</td> -->
                        <td> {{ myrole=='1' || (myrole=='4' && is_doctor_access!='1') ? ipd.phone : '**********' }} </td>
                        <td *ngIf="myrole=='1' || myrole=='4'"><span class='p-2 badge btn-success pointer-cur' (click)="click_to_call_function(ipd.lead_id)">Click to Call</span></td>
                        <td *ngIf="myrole=='1' || myrole=='4'"><span class='p-2 badge btn-primary pointer-cur' (click)="call_details(ipd.lead_id)">Call Details</span></td>
                        <td>
                            <span *ngIf="ipd.patient_age!=0">{{ipd.patient_age}}</span>
                            <span *ngIf="ipd.patient_age==0">-</span>
                        </td>
                        <td>
                            <span *ngIf="ipd.gender!='null'">{{ipd.gender}}</span>
                            <span *ngIf="ipd.gender=='null'">-</span>
                        </td>
                        <td>{{ipd.lead_circle_name}}</td>
                        <td>{{ipd.circle_name}}</td>
                        <td>{{ipd.bd_name}}</td>
                        <td>{{ipd.useremployee_id}}</td>
                        <td>{{ipd.treatment_name}}</td>
                        <td>{{ipd.treatment_categoriesName}}</td>
                        <td>{{ipd.doctor_name}}</td>
                        <td>{{ipd.hospital_name}}</td>
                        <td>
                            {{getRoomCategory(ipd.room)}}
                        </td>
                        <td>{{ipd.room_rent}}</td>
                        <td>{{getPaymentType(ipd.payment_mode)}}</td>
                        <td>
                            <span *ngIf="ipd.emi_vendor_name=='1'">Early Salary</span>
                            <span *ngIf="ipd.emi_vendor_name=='2'">G-Money</span>
                            <span *ngIf="ipd.emi_vendor_name=='3'">Unofin</span>
                            <span *ngIf="ipd.emi_vendor_name=='4'">Shopsy</span>
                            <span *ngIf="ipd.emi_vendor_name=='5'">Credit Fair</span>
                            <span *ngIf="ipd.emi_vendor_name=='6'">Bajaj Finserv EMI</span>
                            <span *ngIf="ipd.emi_vendor_name=='7'">Mahila Money</span>
                            <span *ngIf="ipd.emi_vendor_name=='8'">Liquiloans</span>
                            <span *ngIf="ipd.emi_vendor_name != '1' && ipd.emi_vendor_name != '2'&&ipd.emi_vendor_name != '3' && ipd.emi_vendor_name != '4' && ipd.emi_vendor_name!='5' && ipd.emi_vendor_name!='6' && ipd.emi_vendor_name!='7' && (ipd.emi_vendor_name != '' || ipd.emi_vendor_name != NULL)">{{ipd.emi_vendor_name}}</span>
                        </td>
                        <td>{{ipd.leadCreatedTime*1000|date:'d MMM, yyyy hh:mm aa'}}</td>
                        <td>{{ipd.surgery_date*1000|date:'d MMM, yyyy'}}</td>
                        <td>{{ipd.arrival_time*1000|date:'d MMM, yyyy hh:mm aa'}}</td>
                        <td>{{ipd.treatment_time*1000|date:'hh:mm aa'}}</td>
                        <td *ngIf="myrole!='6' && myrole!='13'">{{ipd.admission_amt}}</td>
                        <td *ngIf="myrole!='6' && myrole!='13'">{{ipd.discharge_amt}}</td>
                        <td *ngIf="myrole!='6' && myrole!='13'">{{ipd.billed_amt}}</td>
                         <!-- for insurance role type -->
                        <td *ngIf="myrole=='5' || myrole=='1' || myrole=='15'">{{ipd.tpa}}</td>
                        <td *ngIf="myrole=='5' || myrole=='1' || myrole=='15'">{{ipd.insurance_company}}</td>
                        <td *ngIf="myrole=='5' || myrole=='1' || myrole=='15'">{{ipd.policy_number}}</td>
                        <td *ngIf="myrole=='5' || myrole=='1' || myrole=='15'">{{ipd.corporate}}</td>
                        <td *ngIf="myrole=='5' || myrole=='1' || myrole=='15'">{{ipd.copay}}</td>
                        <td *ngIf="myrole=='5' || myrole=='1' || myrole=='15'">{{ipd.insurance_description}}</td>
                        <!-- for insurance role type -->
                        <td *ngIf="myrole!='13'">
                            <div *ngIf="ipd.aadhar_copy.length > 0; else noAadhar">
                                <span *ngFor="let aDlink of ipd.aadhar_copy"><a href="{{sc3Url+aDlink.aadhar}}" target="_blank">View</a><br></span>
                            </div>
                            <ng-template #noAadhar>
                                Not uploaded
                            </ng-template>
                        </td>
                        <td *ngIf="myrole!='13'">
                            <div *ngIf="ipd.payment_mode!='1' && ipd.payment_mode!='4' && myrole!='13'; else notUploaded_Insurance">
                                <div *ngIf="ipd.insurance_copy.length > 0; else noInsurance">
                                    <span *ngFor="let insurance of ipd.insurance_copy"><a href="{{sc3Url+insurance.insurance}}" target="_blank">View</a><br></span>
                                </div>
                                <ng-template #noInsurance>
                                    Not uploaded
                                </ng-template>
                            </div>
                            <ng-template #notUploaded_Insurance>
                                <td>-</td>
                            </ng-template>
                        </td>
                        
                        <td *ngIf="myrole!='13'">
                            <div *ngIf="ipd.discharge_summary.length > 0; else noDischarge">
                                <span *ngFor="let dischargelink of ipd.discharge_summary"><a href="{{sc3Url+dischargelink.discharge}}" target="_blank">View</a><br></span>
                            </div>
                            <ng-template #noDischarge>
                                Not uploaded
                            </ng-template>
                        </td>
                        <td *ngIf="myrole!='13'">
                            <div *ngIf="ipd.bill_copy.length > 0; else noBills">
                                <span *ngFor="let bill of ipd.bill_copy"><a href="{{sc3Url+bill.bills}}" target="_blank">View</a><br></span>
                            </div>
                            <ng-template #noBills>
                                Not uploaded
                            </ng-template>
                        </td>


                        <td *ngIf="myrole!='13'">
                            <div *ngIf="ipd.payment_mode=='2' && myrole!='13'; else notUploadedPre_Auth">
                                <div *ngIf="ipd.pre_auth_copy.length > 0; else noPre_Auth">
                                    <span *ngFor="let pre_auth of ipd.pre_auth_copy"><a href="{{sc3Url+pre_auth.pre_auth}}" target="_blank">View</a><br></span>
                                </div>
                                <ng-template #noPre_Auth>
                                    Not uploaded
                                </ng-template>
                            </div>
                            <ng-template #notUploadedPre_Auth>
                                <td>-</td>
                            </ng-template>
                        </td>
                        

                        <td *ngIf="myrole!='13'">
                            <div *ngIf="ipd.payment_mode=='2' && myrole!='13'; else notUploadedPre_Approval">
                            <div *ngIf="ipd.pre_approval_copy.length > 0; else noPre_Approval">
                                <span *ngFor="let pre_approval of ipd.pre_approval_copy"><a href="{{sc3Url+pre_approval.pre_approval}}" target="_blank">View</a><br></span>
                            </div>
                            <ng-template #noPre_Approval>
                                Not uploaded
                            </ng-template>
                            </div>
                            <ng-template #notUploadedPre_Approval>
                                <td>-</td>
                            </ng-template>
                        </td>
                        

                        <td *ngIf="myrole!='13'">
                            <div *ngIf="ipd.payment_mode=='2' && myrole!='13'; else notUploadedFinal_Approval">
                                <div *ngIf="ipd.final_approval_copy.length > 0; else noFinal_Approval">
                                    <span *ngFor="let final_approval of ipd.final_approval_copy"><a href="{{sc3Url+final_approval.final_approval}}" target="_blank">View</a><br></span>
                                </div>
                                <ng-template #noFinal_Approval>
                                    Not uploaded
                                </ng-template>
                            </div>
                            <ng-template #notUploadedFinal_Approval>
                                <td>-</td>
                            </ng-template>
                        </td>
                        

                        <td *ngIf="myrole!='13'">
                            <div *ngIf="ipd.payment_mode!='1' && ipd.payment_mode!='4' && myrole!='13'; else notUploadedSettelment">
                                <div *ngIf="ipd.SettlementDoc_copy.length > 0; else noSettlementDoc">
                                    <span *ngFor="let settledoc of ipd.SettlementDoc_copy"><a href="{{sc3Url+settledoc.SettlementDocs}}" target="_blank">View</a><br></span>
                                </div>
                                <ng-template #noSettlementDoc>
                                    Not uploaded
                                </ng-template>
                            </div>
                            <ng-template #notUploadedSettelment>
                                <td>-</td>
                            </ng-template>
                        </td>
                       

                        <td *ngIf="myrole!='13'">
                            <div *ngIf="ipd.otherDocs.length > 0; else noOtherDocs">
                                <span *ngFor="let otherDoc of ipd.otherDocs"><a href="{{sc3Url+otherDoc.otherDocs}}" target="_blank">View</a><br></span>
                            </div>
                            <ng-template #noOtherDocs>
                                Not uploaded
                            </ng-template>
                        </td>
                        <td>
                            <span *ngIf="ipd.feedbackUserName; else noFeedbackuser">{{ipd.feedbackUserName}}</span>
                            <ng-template #noFeedbackuser>
                                -
                            </ng-template>
                        </td>
                        <td>
                            <span *ngIf="ipd.approvedPersonName; else noApproveduser">{{ipd.approvedPersonName}}</span>
                            <ng-template #noApproveduser>
                                -
                            </ng-template>

                        </td>
                        <td>{{ipd.campaign_name}}</td>
                        <td>{{ipd.keywords}}</td>
                        <td>{{ipd.utm_agid}}</td>
                        <td>{{ipd.matchtype}}</td>
                        <td>{{ipd.zoho_lead_source}}</td>
                        <td *ngIf="myrole=='1' || myrole=='4' ">
                            <span *ngIf="ipd.feedback_followupdate != null; else feedback_followupdate_elseBlock">
                                {{ipd.feedback_followupdate*1000|date:'d MMM, yyyy'}}
                            </span>
                            <ng-template #feedback_followupdate_elseBlock></ng-template>
                        </td>
                        <td *ngIf="myrole=='1' || (myrole=='4' && isCMAccess=='1')">{{ipd.assigned_to}}</td>
                        <td *ngIf="myrole=='1' || (myrole=='4' && isCMAccess=='1')">
                            <div class="dropdown">
                               <button class="btn btn-secondary dropdown-toggle" type="button" id="{{ipd.id}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                   Assign To
                               </button>
                               <div class="dropdown-menu">
                                   <a class="dropdown-item" *ngFor="let feedback_user of feedBackUser;" (click)="updateAssignee(feedback_user.id, ipd.id)"><i class="fa fa-user"></i> {{feedback_user.name}} </a>
                               </div>
                           </div>
                       </td>
                       <td *ngIf="myrole=='1' || myrole=='15'"> 
                           <button class="btn-outline-primary btn pointer-cur" (click)="openPatientJourneyDialog(ipd.id)"><i class="fe fe-truck"></i>
                            Journey Details 
                            </button>
                        </td>
                        <td *ngIf="myrole!='13' && myrole!='15' && myrole!='10' && myrole!='16' && myrole!='7'">
                             <div class="dropdown">
                                <button class="btn btn-secondary dropdown-toggle" type="button" id="{{ipd.id}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Action
                                </button>
                                <div class="dropdown-menu" aria-labelledby="{{ipd.id}}" style="height: 100px; overflow: scroll;">
                                    <a class="dropdown-item" (click)="sharePaymentLink(ipd.lead_id,1)"><i class="fa fa-credit-card"></i>Share Payment Link</a>
                                    <a class="dropdown-item" *ngIf="ipd.status==0 && (myrole=='1' || myrole=='4' || myrole=='9')" (click)="markStatus(ipd.id,1)"><i class="fa fa-check"></i> Complete IPD</a>
                                    <a class="dropdown-item" *ngIf="ipd.status==0 && myrole!='5' && myrole!='8' && myrole!='14'" (click)="markStatus(ipd.id,3)"><i class="fa fa-times"></i> Cancel IPD</a>
                                    <a class="dropdown-item" *ngIf="myrole!='6'" (click)="openIpdDialog(ipd.lead_id)" ><i class="fa fa-pen"></i> Update IPD</a>
                                    <a class="dropdown-item" *ngIf="(myrole=='4' && is_doctor_access=='1') || ipd.status!='4' && myrole!='14' && myrole!='6'" (click)="openIpdTransaction(ipd.lead_id,ipd.id,ipd.treatment_id)"><i class="fa fa-rupee-sign"></i> IPD Transaction</a>
                                    <a class="dropdown-item" (click)="viewIpd(ipd.id)"><i class="fa fa-eye"></i> View IPD</a>
                                    <a *ngIf="myrole=='1' || myrole=='4' || myrole=='6'" class="dropdown-item" routerLink="/add-ipd-feedback/{{ipd.id}}"><i class="fa fa-comments"></i>
                                        Add Feedback
                                    </a>
                                    <a *ngIf="ipd.complaintId==null && (myrole=='1' || myrole=='4' || myrole=='6')" class="dropdown-item" routerLink="/add-ipd-complaint/{{ipd.id}}"><i class="fa fa-comments"></i>
                                        Add Complaint
                                    </a>
                                    <a *ngIf="ipd.complaintId!=null && (myrole=='1' || myrole=='4' || myrole=='6')" class="dropdown-item" routerLink="/update-ipd-complaint/{{ipd.id}}/{{ipd.id}}"><i class="fa fa-comments"></i>
                                        Update Complaint
                                    </a>
                                    <a *ngIf="myrole=='1'  || userId == '19'" class="dropdown-item" (click)="viewBilledHistory(ipd.id)"><i class="fa fa-eye"></i> View History</a>


                                    <a *ngIf="myrole=='1' || userId=='1' ||  userId=='3' || userId=='5' || userId=='45' || userId=='73'" class="dropdown-item" (click)="showDuplicateModal(ipd.id,ipd.lead_id)"><i class="fa fa-comments"></i>
                                        Create Second Disease
                                    </a>

                                    <a *ngIf="(myrole=='1' || userId=='19' ||  userId=='114' || userId=='250') && ipd.isElective=='0'" class="dropdown-item" (click)="markasElective(ipd.id)"><i class="fa fa-check"></i>
                                        Mark as elective surgery
                                    </a>
                                   
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr *ngIf="loading">
                        <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                    </tr>
                    <tr *ngIf="loaded && !ipds.length">
                        <td colspan="20" ><i class="far fa-frown"></i> Ipds not found</td>
                    </tr>
                </tbody>
            </table>

            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>
    </div>
</div>

<!-- The Modal to view ipd -->
<div class="modal fade" id="myModal">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">IPD Schedule </h4>
        <button type="button" class="close" (click)="hideModal('1')"></button>
      </div>

      <!-- Modal body -->
      <div class="modal-body"id="pdfTable" #pdfTable>
        <div><h3><span style="color:#0f74b2">Glamyo</span>&nbsp;<span style="color:#69bb45">Health</span></h3></div>
        <table>
            <tr>
                <th colspan="2"><i><span style="color:red">**Note: 6 hours fasting is mandatory before admission.</span> </i></th>
            </tr>
            <tr>
              <th colspan="2">IPD Details</th>

            </tr>
            <tr>
                <td><strong>Ipd Id -</strong></td>
                <td> GHIPD{{ipdDetail.id}}</td>
            </tr>
            <tr>
                <td><strong>Patient Name -</strong></td>
                <td>{{ipdDetail.patient}}</td>
            </tr>
            <tr>
                <td><strong>Medical Coordinator -</strong></td>
                <td>{{ipdDetail.bd_name}}</td>
            </tr>
            <tr>
                <td><strong>Doctor Name -</strong></td>
                <td>{{ipdDetail.doctor_name}}</td>
            </tr>
            <tr>
                <td><strong>Treatment -</strong></td>
                <td>{{ipdDetail.treatment_name}}</td>
            </tr>
            <tr>
                <td><strong>Hospital Name -</strong></td>
                <td>{{ipdDetail.hospital_name}}</td>
            </tr>
            <tr>
                <td><strong>Address -</strong></td>
                <td>{{ipdDetail.address}}</td>
            </tr>
            <tr>
                <td><strong>Location -</strong></td>
                <td><span style="color: blue; text-decoration: underline;">{{ipdDetail.location}}</span></td>
            </tr>
            <tr>
                <td><strong>Surgery Date -</strong></td>
                <td>{{ipdDetail.surgery_date*1000 | date:'dd MMM, yyyy'}}</td>
            </tr>
            <tr>
                <td><strong>Arrival Time at the center -</strong></td>
                <td>{{ipdDetail.arrival_time*1000|date:'hh:mm aa'}}</td>
            </tr>
            <tr>
                <td><strong>Treatment Time -</strong></td>
                <td>{{ipdDetail.treatment_time*1000|date:'hh:mm aa'}}</td>
            </tr>
            <tr>
                <td><strong>Test -</strong></td>
                <td>{{ipdDetail.test}}</td>
            </tr>
            <tr>
                <td><strong>Attendant -</strong></td>
                <td>{{ipdDetail.attendant}}</td>
            </tr>
            <tr>
                <td><strong>Payment Type -</strong></td>
                <td>{{getPaymentType(ipdDetail.payment_mode)}}</td>
            </tr>
            <tr *ngIf="ipdDetail.payment_mode=='2' || ipdDetail.payment_mode=='3'">
                <td><strong>Copay -</strong></td>
                <td>
                    <span *ngIf="ipdDetail.copayData && ipdDetail.copayData!='NIL' && ipdDetail.copayData!=1">{{ipdDetail.copayData}}%</span>
                    <span *ngIf="ipdDetail.copayData=='NIL' || ipdDetail.copayData==1">NIL</span>
                    <span *ngIf="!ipdDetail.copayData">-</span>

                </td>
            </tr>
            <tr>
                <td><strong>Hospital Room Category  -</strong></td>
                <td>{{getRoomCategory(ipdDetail.room)}} <span  *ngIf="ipdDetail.payment_mode=='2' || ipdDetail.payment_mode=='3'">(Please confirm as per Insurance T&C.)</span></td>
            </tr>
            <tr *ngIf="ipdDetail.payment_mode=='2' || ipdDetail.payment_mode=='3'">
                <td><strong>Room Rent Capping -</strong></td>
                <td>{{ipdDetail.room_rent}}</td>
            </tr>
        </table>
      </div>

      <!-- Modal footer -->
      <div class="modal-footer">
        <button class="btn btn-primary" (click)="downloadAsPDF()">Share</button>
        <button type="button" class="btn" (click)="hideModal('1')">Close</button>
      </div>
    </div>
  </div>
</div>


<!-- The Modal to view Billed Amount History -->
<div class="modal fade" id="BilledModal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content ">

        <!-- Modal Header -->
        <div class="modal-header">
          <h5 class="modal-title billedTitle">IPD History</h5>
          <button type="button" class="close" (click)="hideModal('2')"></button>
        </div>

        <!-- Modal body -->
        <div class="modal-body history_modal">
        <div class="col-sm-12 ">
            <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                <tbody>
                    <tr *ngFor="let ipdbilled of ipdHistoryDetail">
                        <td class="no-padding-bottom">
                            <div class="small_text" [innerHTML]="ipdbilled.message | safe:'html'"></div>
                            <div class="small text-muted small_text_creation">
                                <i class="fas fa-clock"></i> {{ipdbilled.created_at*1000|date:'d MMM, yyyy H:mm aa'}}
                            </div>
                        </td>
                    </tr>
                    <tr *ngIf="!ipdHistoryDetail.length && billedloaded">
                        <td>No history found</td>
                    </tr>
                    <tr *ngIf="billedloading">
                        <td><i class="fa fa-spin fa-spinner"></i></td>
                    </tr>
                </tbody>
            </table>
        </div>
        </div>
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideModal('2')">Close</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Duplicate Modal -->
<div class="modal fade" id="duplicateModal">
    <div class="modal-dialog">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Create Second Disease</h4>
          <button type="button" class="close" (click)="hideduplicateModal()"></button>
        </div>

        <!-- Modal body -->
          <div class="modal-body">
              <div class="form-group">
                  <div class="row">
                    <div class="col-sm-12"><h2>Do you want to create second disease IPD?</h2></div>

                    <div *ngIf="copyIPDData" class="col-sm-12 text-center" style="font-size: 22px;"><span><i class="fa fa-spin fa-spinner"></i> Uploading...</span></div>

                  </div>

              </div>
          </div>

        <!-- Modal footer -->
        <div class="modal-footer">
           <button type="button" class="btn btn-success" (click)="copyLeadIpd()">Confirm</button>
          <button type="button" class="btn" (click)="hideduplicateModal()">Close</button>
        </div>
      </div>
    </div>
  </div>

<!-----------------For Click to Call-------------------------->
<div class="modal fade" id="click_to_call_progress" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title" style="font-weight: bold;">Call Progression</h4>
        </div>
  
        <!-- Modal body -->
          <div class="modal-body">
                <div class="alert alert-danger" *ngIf="progression_msg">
                  <strong>Warning!</strong> {{progression_msg}}
                </div>
                <div class="form-group">
                  <div class="row">
                    <div style="font-size: 18px;" class="col-sm-12 modal-title text-center" id="click_to_call_progress_html">
                      <i class="fa fa-cog fa-spin"></i><br />
                      <h2>Call is under progress.</h2>
                    
                    </div>
                  </div>
                </div>
          </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" [disabled]="end_to_call_btn_disable" class="btn btn-success" (click)="endClicktoCall()">Close</button>
        </div>
      </div>
    </div>
</div>

<!-----------------Ipd call Details-------------------------->
<div class="modal fade" id="ipd_call_details" data-keyboard="false" data-backdrop="static" style="margin-top:80px ;">
    <div class="modal-dialog modal-lg modal-dialog">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title" style="font-weight: bold;">Call Details</h4>
        </div> 
        <!-- Modal body -->
          <div class="modal-body">
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm-12 modal-title text-center">
                        <div style="overflow-x:auto;">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">Name</th>
                            <th scope="col">Duration <small>(In Minutes)</small></th>
                            <th scope="col">Time</th>
                            <th colspan="2">Call Recording Link</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let callData of callDeatils;let index = index;">
                            <th scope="row">{{index+1}}</th>
                            <td>{{callData.call_by_name}}</td>
                            <td>{{(callData.call_duration/60)|number : '.2-2'}}</td>
                            <td> {{callData.created_at*1000|date:'d MMM, yyyy H:mm aa'}}</td>
                            <td [innerHTML]="callData.click_to_call_recording_links"></td>
                            <td>
                            <button  class="pointer-cur" (click)="copyMessage('http://'+callData.click_to_call_link_only)"><i class="fa fa-copy"></i></button>
                            </td>
                          </tr>
                          <tr *ngIf="loaded && !callDeatils.length">
                            <td colspan="5"><i class="far fa-frown"></i> Data not found</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
          </div>
  </div>
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button"  class="btn btn-success" id="ipd_call_details" (click)="closeCallDetailsModal()">Close</button>
        </div>
      </div>
    </div>
</div>

<!-- The Modal For Update IPD Assigned To -->
<div class="modal fade" id="myModalIPDAssignedtoUpdate">
    <div class="modal-dialog">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Import Data </h4>
          <button type="button" class="close" (click)="hideIPDAssignedToUpdateModal()"></button>
        </div>
  
        <!-- Modal body -->
          <div class="modal-body">
              <div class="form-group">
                  <div class="row">
                      <label class="col-sm-12">Upload CSV</label>
                      <input [disabled]="assigned_to_submitted" type="file" #csvUploadPxAssignedTeam (change)="selectFileUpdatePxAssignedTo($event)" class="form-control" />
                  </div>
                  <span *ngIf="assigned_to_submitted"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
              </div>
              <div class="form-group" *ngIf="updatedPxAssignedToLeadId || notupdatedPxAssignedToLeadId">
                <div class="row">
                    <div class="col-sm-12">
                        <h5><span style="word-wrap: break-word;"><b>Updated Lead Ids : </b>{{updatedPxAssignedToLeadId}}</span></h5>
                        <h5><span style="word-wrap: break-word;"><b>Not Updated Lead Ids : </b>{{notupdatedPxAssignedToLeadId}}</span></h5>
                    </div>
                </div>
            </div>
          </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideIPDAssignedToUpdateModal()">Close</button>
        </div>
      </div>
    </div>
</div>

<!-- Glamyo Shares Modal -->
<div class="modal fade" id="myModalGlamyoShares">
    <div class="modal-dialog">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Import Shares </h4>
          <button type="button" class="close" (click)="hideModalGlamyoShares()"></button>
        </div>
  
        <!-- Modal body -->
          <div class="modal-body">
              <div class="form-group">
                  <div class="row">
                      <label class="col-sm-12">Upload CSV</label>
                      <input [disabled]="submitted" type="file" #csvUploadShares (change)="selectFileIpdShare($event)" class="form-control" />
                  </div>
                  <span *ngIf="submitted"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
              </div>
          </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideModalGlamyoShares()">Close</button>
        </div>
      </div>
    </div>
</div>
